import type { Money } from '@fourthwall/services/dist/models/common'
import { formatCurrency } from '@fourthwall/utils/dist/currency'

export const convertNumberToMoney = (value: number, currency = 'USD'): Money => ({
  value: parseFloat(formatCurrency(value)),
  currency,
})
